import { UploadAssetFieldMui } from '@app/modules/assets/screens/upload/components/UploadAssetFieldMui';
import { Box } from '@mui/material';
import { useIntl } from 'react-intl';

export function InstagramExportSettings({ fieldPrefix }: { fieldPrefix?: string }) {
  const { $t } = useIntl();
  return (
    <Box>
      <UploadAssetFieldMui
        name={`${fieldPrefix || ''}.config.coverUrl`.replace(/^\./, '')}
        inputProps={{
          label: $t({
            id: 'common.loadCoverImage',
            defaultMessage: 'Cargar imagen de portada',
          }),
          size: 'sm',
          accept: 'image/*',
          maxSizeMb: 8,
        }}
      />
    </Box>
  );
}
